<template>
    <div class="login-page">
        <div class="container container--mw-xxxl login-page__container">
            <div class="row justify-content-between">
                <div class="col login-page__column">
                    <div v-if="userLoginErrorStatus" class="loginErrorMsgBox">
                        <p class="body-copy body-copy--align-center body-copy--color-error">{{this.userLoginErrorMsg}}</p>
                    </div>

                    <div v-if="userActivationSuccessMsg" class="loginErrorMsgBox">
                        <p class="body-copy body-copy--align-center">Your Account has been Activated</p>
                    </div>

                    <div v-if="userActivationErrorMsg" class="loginErrorMsgBox">
                        <p class="body-copy body-copy--align-center body-copy--color-error">User Activation Failed</p>
                    </div>

                    <FormulateForm @submit="loginUser">
                        <h1 class="formulate-form__heading">Welcome back</h1>

                        <FormulateInput
                            v-model="user_email"
                            type="email"
                            name="email"
                            label="Email"
                            validation="required|email"
                            :wrapper-class="['formulate-input-wrapper--container']"
                            :label-class="['formulate-input-label--contained']"
                            :element-class="['formulate-input-element--contained']"
                        />

                        <FormulateInput
                            v-model="user_password"
                            type="password"
                            name="password"
                            label="Password"
                            validation="required"
                            :wrapper-class="['formulate-input-wrapper--container']"
                            :label-class="['formulate-input-label--contained']"
                            :element-class="['formulate-input-element--contained']"
                        />

                        <FormulateInput
                            v-model="isRemembeMeChecked"
                            type="checkbox"
                            label="Remember Me"
                            :wrapper-class="['formulate-input-wrapper--checkbox']"
                            :label-class="['formulate-input-label--checkbox']"
                        />

                        <div class="formulate-form__form-footer">
                            <FormulateInput
                                type="submit"
                                name="SIGN IN"
                                :input-class="'btn formulate-form__submit'"
                            />

                            <router-link to="/forgotten-password" class="formulate-form__link">Forgot your password?</router-link>
                        </div>
                    </FormulateForm>
                </div>

                <div class="col-12 col-lg-1">
                    <span class="login-page__or">OR</span>
                </div>

                <div class="col login-page__column">
                    <div class="login-page__sign-up-cta">
                        <p class="login-page__sign-up-copy">New around Here?</p>

                        <AppButton :text="'SIGN UP'" :link="'/join'" class="login-page__sign-up-button" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import InlineSvg from "vue-inline-svg";
    import userMixin from "../mixins/userMixin";
    import AppButton from "@/components/ui/AppButton";

    export default {
        name: 'LoginPage',
        metaInfo: {
            title: 'Khonsu - Login'
        },
        components: {
            AppButton
        },
        computed: {},
        watch: {},
        data() {
            return {
                user_email: '',
                user_password: '',
                userLoginErrorStatus: false,
                userLoginErrorMsg: '',
                userActivationSuccessMsg: false,
                userActivationErrorMsg: false,
                isRemembeMeChecked:false
            }
        },
        methods: {
             lsRememberMe() {
                if ((this.isRemembeMeChecked === true) && (this.user_email !== "")) {
                    localStorage.rememberMe_Email = this.user_email;
                    localStorage.rememberMe_Password = this.user_password;
                    localStorage.rememberMe_checkbox = this.isRemembeMeChecked;
                } else {
                    localStorage.rememberMe_Email = "";
                    localStorage.rememberMe_Password = '';
                    localStorage.rememberMe_checkbox = false;
                }
            },

            async loginUser() {
                let userLogin = await this.$store.dispatch('UserManagement/loginUser', {
                    "email": this.user_email,
                    "password": this.user_password
                });
                if (!userLogin) {
                    //Login Failed
                    let errorCode = userMixin.methods.getUserLoginErrorStatus();
                    this.userLoginErrorStatus = true;
                    switch (errorCode) {
                        case '403':
                            this.userLoginErrorMsg = JSON.parse(sessionStorage.getItem('_khonsu_user_login_failed_msg')).message;

                            break;
                        case '401':
                            this.userLoginErrorMsg = JSON.parse(sessionStorage.getItem('_khonsu_user_login_failed_msg')).message;

                            break;
                        case '429':
                            this.userLoginErrorMsg = JSON.parse(sessionStorage.getItem('_khonsu_user_login_failed_msg')).message;

                            break;
                        case '404':
                            this.userLoginErrorMsg = JSON.parse(sessionStorage.getItem('_khonsu_user_login_failed_msg')).result;

                            break;
                        default:
                            break;

                    }


                }
                if (userLogin) {
                    //true
                    /* login successful*/
                    this.lsRememberMe()
                    window.location.href = '/brand-creator'
                    //this.$router.push('/my-account');
                }
            }
        },
        mounted() {


            if (localStorage.rememberMe_checkbox && localStorage.rememberMe_checkbox !== "") {
                this.isRemembeMeChecked= true;
                this.user_password=localStorage.rememberMe_Password
                this.user_email = localStorage.rememberMe_Email;
            } else {
                this.isRemembeMeChecked=false;
                this.user_password ='';
                this.user_email = '';

            }
            if (sessionStorage.getItem("_khonsu_user_Activation_failed_msg") !== null) {
                if (JSON.parse(sessionStorage.getItem('_khonsu_user_Activation_failed_msg')).message != null) {
                    this.userActivationErrorMsg = true;
                }
            }
            if (sessionStorage.getItem("_khonsu_user_Activation_success_msg") !== null) {
                if (JSON.parse(sessionStorage.getItem('_khonsu_user_Activation_success_msg')).message != null) {
                    this.userActivationSuccessMsg = true;
                }
            }

            setTimeout(function () {
                if (sessionStorage.getItem("_khonsu_user_Activation_failed_msg") !== null) {
                    sessionStorage.removeItem('_khonsu_user_Activation_failed_msg');
                }
                if (sessionStorage.getItem("_khonsu_user_Activation_success_msg") !== null) {
                    sessionStorage.removeItem('_khonsu_user_Activation_success_msg');
                }
            }, 2000);


        }
    }
</script>

<style lang="scss">
    #login-page {
        padding-bottom: 100px;

        .formulate-form {
            .formulate-input-errors {
                color: #fff;
            }


            .formulate-input {
                &:nth-of-type(2) {
                    margin-bottom: 0;
                }

                .formulate-input-wrapper {
                    .formulate-input-element--password {
                        margin-bottom: 10px;
                    }
                }
            }
        }

        .pass-reset {
            text-align: right;
            display: flex;
            justify-content: space-between;
            .remember-me{
                .formulate-input-wrapper{
                    display: flex;

                }
                label{
                    color: white;
                    padding-left: 3px ;
                    font-size: 14px;
                }

            }
            a {
                display: inline-block;
                margin-bottom: 40px;
                font-size: 14px;
                color: $mainColor;
                text-decoration: none;
            }
        }

        .sign-up {
            margin-top: 30px;
            font-size: 14px;
            color: $mainColor;
            text-align: center;

            a {
                font-size: inherit;
                color: $mainColor;
                text-decoration: underline;
            }
        }

        .loginErrorMsgBox {

            padding: 2%;
            width: 100%;
            display: flex;
            justify-content: center;
            background-color: tomato;
            border-radius: 11px;
            color: white;

        }
    }
</style>